import { _js } from '@ifixit/localize';
import { RangeSlider } from 'Shared/range_slider';
import { MediaManager } from 'Shared/FrameModules/MediaLibrary/media_manager';
import { MinimalMediaTarget } from 'Shared/FrameModules/MediaLibrary/minimal_target';
import { StatusNotice } from 'Shared/status_notice';
import { Utils } from 'Shared/utils';
import { Auth } from 'Shared/auth';
import { LoadingStatus } from 'Shared/modal';
import { FormManager } from 'Shared/form_manager';
import { WikiImageManager } from 'Guide/FrameModules/wiki_image';
import {
   WikiTextEditor,
   insertAtCursor,
   insertAroundCursor,
   getSelectedText,
} from 'Shared/wiki_text_editor';
import EditorCache from 'Shared/prosemirror/editorcache';
import { RelatedWikiForm } from './related_wiki_form';
import { CookieUtils } from 'Shared/cookies/cookie-utils';
import { getSerializedText, getEditor } from 'Shared/prosemirror/tiptap/editor_cache';
import copyToClipboard from 'Shared/copy_to_clipboard';
import LegacyEditorHandle from 'Guide/legacy_editor_handle';
import wikiEditDocumentTemplate from 'ejs/wiki_edit_document.ejs';
import Template from 'Shared/template';

onDomReady(() => {
   if ($('wikiForm')) {
      WikiEditor.initialize();
   } else {
      document.addEventListener('wikiFormRendered', () => {
         WikiEditor.initialize();
      });
   }

   when($('wiki-documents'), docManager => {
      WikiDocuments.initialize(docManager);
   });

   when($('relatedWikiForm'), form => {
      RelatedWikiForm.initialize(form);
   });

   when($('copy-wikiid-link'), () => {
      $('copy-wikiid-link').addEvent('click', ev => {
         ev.stop();
         let copyText = ev.target.childNodes[2].nodeValue;
         ev.target.childNodes[2].nodeValue = _js('Copied!');

         copyToClipboard(App.wikiid);

         setTimeout(() => {
            ev.target.childNodes[2].nodeValue = copyText;
         }, 5000);
      });
   });
   // Toggle the display state of the translation diff.
   when($$('.js-toggle-diff'), items => {
      items.addEvent('click', () => {
         $$('.toggleDiff').each(el => {
            el.toggleClass('hidden');
         });
      });
   });
});

// If the intro EditorCache entry hasn't been defined, set up the legacy
// wikitext editor.

export function wikiTextLegacyEditorInit() {
   onDomReady(() => {
      WikiShortcuts.initialize();
   });
   EditorCache.set('wikiTextField', LegacyEditorHandle('wikiTextField'));
   // Set up the toolbar on the introduction box.
   const items = ['heading', 'bold', 'italic', 'ul', 'ol', 'link', 'video', 'media'];
   const wikiTextEditor = new WikiTextEditor('wikiTextField', null, {
      toolbarItems: items,
      className: 'wikiTextEditorToolbar',
      helpLink: window.guide_constants.GuideURI('TAG_FORMATTING_HELP'),
      helpText: _js('Formatting help'),
   });
   if (wikiTextEditor.mediaTarget) {
      wikiTextEditor.mediaTarget.addEvent('itemChanged', mediaItem => {
         WikiImageManager.addImage(mediaItem);
      });
   }
}

const WikiEditor = {
   initialize: function () {
      this.form = $('wikiForm');
      this.saved = false;
      this.origText = $('origText');
      this.keyTitle = $('keyTitle');
      this.wikiText = $('wikiTextField');
      this.previewDiv = $('wikiPreviewDiv');
      this.diffDiv = $('wikiDiffDiv');
      this.noChangesDiv = $('wikiNoChangesDiv');
      this.reviewDivs = [this.previewDiv, this.diffDiv, this.noChangesDiv];
      this.modeDivs = $$('.modeInputDiv');
      this.scrollEl = false;

      let fm = new FormManager(this.form);
      this.formLoading = new LoadingStatus(this.form);

      fm.addSubmitHandler(() => {
         Auth.required({
            from: this.form,
            message: _js('Log in to save this text'),
            onAuthorize: function () {
               this.saved = true;
               this.formLoading.loading(_js('Saving...'));

               let requestFailure = function (xhr, message) {
                  this.saved = false;
                  this.formLoading.doneLoading();
                  this.displayError(message);
               }.bind(this);

               let saveRequest = new Request.API_2_0(App.editUrl, {
                  method: App.editMethod,
                  onSuccess: function () {
                     this.setWikiStatusCookie('saved');
                     window.location = App.redirectUrl;
                  }.bind(this),
                  onFailure: requestFailure,
               });

               saveRequest.send(this.getFormValues());

               return false;
            }.bind(this),
         });
      });

      WikiRepairability.initialize();

      // Initialize the tag editor.
      when($('tagList'), () => {
         TagEditor.initialize();
      });

      when($('wikiSummary'), textarea => {
         let defaultText = _js(
            'Brief one or two sentences with identification info.%1Example: Released June 2009, identified by model number A1303.',
            '\n\n'
         );

         textarea.placeholder = defaultText;
      });

      when($('wikiText'), textarea => {
         fm.setDefaultText(textarea, $('defaultText').value);
      });

      when($('toggleAdvanced'), toggle => {
         let wikiTextField = this.wikiText.getParent();
         if (this.origText.get('value') == '') {
            wikiTextField.hide();
         }

         toggle.addEvent('click', ev => {
            ev.stop();
            wikiTextField.toggle();
         });
      });

      when($('toc'), el => {
         el.addEvent('click', () => {
            let checked = el.checked;

            if (checked) {
               el.setAttribute('checked', 'checked');
            } else {
               el.removeAttribute('checked');
            }
         });
      });

      this.modeDivs.each(div => {
         let input = div.getElement('input');
         input.addEvent('change', () => {
            let mode = input.get('value');
            this.setEditMode(mode);
         });
      });

      $('quickSave').addEvent('click', ev => {
         ev.stop();
         fm.submit();
      });

      when($('confirmForm'), el => {
         el.addEvent('submit', ev => {
            ev.stop();
            fm.submit();
         });
      });

      $('previewWikiButton').addEvent('click', ev => {
         ev.stop();
         this.scrollEl = $('wikiPreviewDiv');
         this.renderText();
      });

      when($('deleteWikiButton'), el => {
         el.addEvent('click', ev => {
            ev.stop();
            let confMsg = _js('Are you sure you want to delete the entire page?');
            if (confirm(confMsg)) {
               $('deleteInput').set('value', 'true');
               Auth.required({
                  from: $('saveButton'),
                  message: _js('Log in to save this text'),
                  onAuthorize: function () {
                     this.saved = true;

                     this.formLoading.loading(_js('Deleting...'));

                     new Request.API_2_0(App.editUrl, {
                        method: 'delete',
                        onSuccess: function () {
                           this.setWikiStatusCookie('deleted');
                           window.location = App.redirectUrl;
                        }.bind(this),
                        onFailure: function (xhr, message) {
                           this.formLoading.doneLoading();
                           this.displayError(message);
                        }.bind(this),
                     }).send();
                  }.bind(this),
               });
            }
         });
      });

      Utils.UnsavedChanges.addHandler(() => {
         if (this.wikiText.hasClass('defaultText') || this.saved) {
            return;
         }

         const handle = getEditor('wikiTextField');

         let currentDoc;
         let originalDoc;

         if (!handle) {
            // The editor is probably not booted yet, and the user's
            // already leaving the page.
            return;
         }
         currentDoc = handle.state.doc;
         originalDoc = handle.storage.originalState.savedContent;

         if (!currentDoc || !originalDoc) {
            return;
         }
         if (!currentDoc.eq(originalDoc)) {
            return _js('You have unsaved changes. Your changes will be lost if you continue.');
         }
      });
   },

   // Sets a short-lived Cookie that will trigger a status message on wiki view.
   setWikiStatusCookie: function (value) {
      CookieUtils.set('wiki_updated', value, {
         maxAgeInSeconds: 2,
      });
   },

   displayError: function (message) {
      let statusNoticeDiv = $('statusNoticeDiv');
      let notice = new StatusNotice();
      statusNoticeDiv.adopt(notice.element);
      notice.error(message);
      statusNoticeDiv.jumpTo();
   },

   /**
    * Returns an object with all the form values that should be sent to the
    * API.
    */
   getFormValues: function () {
      // Translation split view duplicates ids on several elements because we
      // don't want to rewrite or pollute our augment templates.
      // To make sure that we are sending the translation's data along when we
      // save, we have to get rid of the ids on the read-only half of the
      // screen.
      if (App.translating) {
         let readOnlyElementsWithIds = $$('.wikiSplitL *[id]');
         readOnlyElementsWithIds.removeProperty('id');
      }

      let allPossibleValues = {
         description: {
            id: 'wikiSummary',
         },
         display_title: {
            id: 'wikiTitle',
         },
         contents: {
            id: 'wikiTextField',
            getValue: function () {
               return getSerializedText('wikiTextField');
            },
         },
         table_of_contents: {
            id: 'toc',
            getValue: function () {
               return $('toc').get('checked');
            },
         },
         documents: {
            id: 'wiki-documents',
            getValue: function () {
               return WikiDocuments.getFormValues();
            },
         },
         repairability_score: {
            id: 'wikiRepairability',
            getValue: function (repairability) {
               let score = Number.parseInt(repairability.value, 10);
               if (score < 0 || score > 10) {
                  score = null;
               }

               return score;
            },
         },
         image: {
            id: 'wikiSummaryImageid',
            getValue: function () {
               return Number.parseInt($('wikiSummaryImageid').value, 10);
            },
         },
         page_title: {
            id: 'pageTitle',
         },
         suppliers: {
            id: 'suppliers',
            getValue: function () {
               return WikiSuppliers.getFormValues();
            },
         },
         info: {
            id: 'wikiInfoTable',
            getValue: function () {
               return WikiInfo.getFormValues();
            },
         },
      };

      let values = {};
      Object.each(allPossibleValues, (field, name) => {
         let element = $(field.id);

         if (!element) {
            return;
         }

         let value;
         if (element.hasClass('defaultText')) {
            value = '';
         } else if ('getValue' in field) {
            value = field.getValue(element);
         } else {
            value = element.value;
         }

         values[name] = value;
      });

      if (App.creatingNewWiki) {
         values.namespace = App.wikiNamespace;
         values.title = App.wikiTitle;
      }

      if (App.creatingNewWiki || ($('syncCheckbox') && $('syncCheckbox').get('checked'))) {
         values.source_revisionid = App.wikiSourceRevisionid;
      }

      // Always use flags from wiki text to avoid making a nice UI for it.
      values.use_wiki_text_flags = true;

      return values;
   },

   getPreviewValues: function () {
      return {
         wikiPatch: this.getFormValues(),
         namespace: App.wikiNamespace,
         title: App.wikiTitle,
      };
   },

   setEditMode: function (mode) {
      mode = mode.toString().toInt();

      this.modeDivs.each(el => {
         if (el.get('data-mode').toInt() == mode) {
            el.addClass('activeRadioInput');
         } else {
            el.removeClass('activeRadioInput');
         }
      });
   },

   clearTextField: function (input) {
      if (input != null && input.getProperty('data-example') != '') {
         input.value = '';
      }
   },

   renderText: function () {
      this.formLoading.loading(_js('Loading Preview...'));
      new Request.AjaxIO('previewWikiText', {
         onSuccess: function (response) {
            let diffDiv = $('wikiDiffDiv');
            let previewDiv = $('wikiPreviewDiv');

            $('mainBody').grab(previewDiv);
            $('mainBody').grab(diffDiv);

            if (response.diff) {
               $('diffText').set('html', response.diff);
               diffDiv.show();
            } else {
               diffDiv.hide();
               $('diffText').set(
                  'html',
                  '<p style="text-align:center">' + _js('No Changes') + '</p>'
               );
            }

            if (response.rendered) {
               previewDiv.show();
               $('renderedText').set('html', response.rendered);
               $('renderedText')
                  .getElements('a')
                  .each(a => {
                     a.addEvent('click', ev => {
                        ev.stop();
                     });
                  });

               $('wikiPreviewDiv').jumpTo();
            }

            this.formLoading.doneLoading();
         }.bind(this),
      }).send(this.getPreviewValues());
   },
};

const WikiShortcuts = {
   initialize: function () {
      WikiEditor.form.addEvent('keydown', ev => {
         if (ev.meta || ev.control) {
            if (ev.key == 'b') {
               ev.stop();
               this.toggleWikiFormatting(ev.target, "'''");
            } else if (ev.key == 'i') {
               ev.stop();
               if (
                  this.hasWikiFormatting(ev.target, "'''") &&
                  !this.hasWikiFormatting(ev.target, "'''''")
               ) {
                  this.addWikiFormatting(ev.target, "''");
               } else {
                  this.toggleWikiFormatting(ev.target, "''");
               }
            } else if (ev.key == 'u') {
               ev.stop();
               this.toggleWikiFormatting(ev.target, '++');
            }
         }
      });
   },

   toggleWikiFormatting: function (form, text) {
      if (getSelectedText(form)) {
         let start = form.selectionStart;
         let end = form.selectionEnd;

         this.ignoreOtherFormatting(form, text);

         if (this.hasWikiFormatting(form, text)) {
            this.removeWikiFormatting(form, text);
            form.setSelectionRange(start, end - 2 * text.length);
         } else if (
            // eslint-disable-next-line no-dupe-else-if
            form.setSelectionRange(start - text.length, end + text.length) &&
            this.hasWikiFormatting(form, text)
         ) {
            this.removeWikiFormatting(form, text);
            form.setSelectionRange(start - text.length, end - text.length);
         } else {
            form.setSelectionRange(start, end);
            this.addWikiFormatting(form, text);
         }
      } else {
         insertAtCursor(form, text);
      }
   },

   hasWikiFormatting: function (form, text) {
      let selection = getSelectedText(form);
      return (
         selection.indexOf(text) === 0 &&
         selection.lastIndexOf(text) === selection.length - text.length
      );
   },

   removeWikiFormatting: function (form, text) {
      insertAtCursor(
         form,
         getSelectedText(form).substring(text.length, getSelectedText(form).length - text.length)
      );
   },

   addWikiFormatting: function (form, text) {
      insertAroundCursor(form, { before: text, after: text });
      form.setSelectionRange(form.selectionStart - text.length, form.selectionEnd + text.length);
   },

   ignoreOtherFormatting: function (form, text) {
      const formats = ["'''", "''", '++', '``', '^^', ',,', '~~'];
      formats.forEach(format => {
         if (
            format != text &&
            this.hasWikiFormatting(form, format) &&
            !this.hasWikiFormatting(form, text)
         ) {
            form.setSelectionRange(
               form.selectionStart + format.length,
               form.selectionEnd - format.length
            );
         }
      });
   },
};

// WIKI DOCUMENT UPLOADER /////////////////////////////////////////////////////

const WikiDocuments = {
   initialize: function (docManager) {
      this.container = docManager;
      this.uploadLink = docManager.getElement('.js-doc-upload-link');
      this.docList = docManager.getElement('.doc-body');
      this.countEl = docManager.getElement('.doc-count');

      let target = new MinimalMediaTarget({
         customAttach: function (mediaItem, finished) {
            this.appendDocument(mediaItem);
            finished(/* old */ null, /* success */ true);
         }.bind(this),
         accepts: 'guide_document',
      });

      this.uploadLink.addEvent('click', () => {
         MediaManager.browse(target);
      });

      let docs = this.docList.getElements('.doc');
      docs.each(this.addEvents, this);
      this.count = docs.length;
   },

   appendDocument: function (mediaItem) {
      let template = Template.get(wikiEditDocumentTemplate);

      let docEl = template({
         i: this.count,
         docid: mediaItem.getID(),
         filename: mediaItem.getFilename(),
         title: mediaItem.getTitle(),
         iconClassname: mediaItem.getIconClassname(),
      });

      this.docList.grab(this.addEvents(docEl));
      this.adjustCount(1);
   },

   deleteDocument: function (docEl) {
      docEl.dispose();
      this.adjustCount(-1);
   },

   addEvents: function (docEl) {
      docEl.getElement('.doc-delete').addEvent('click', () => {
         this.deleteDocument(docEl);
      });
      docEl.getElement('.doc-title').addEvent('click', ev => {
         ev.stop();
         this.editTitle(docEl);
      });
      return docEl;
   },

   editTitle: function (docEl) {
      docEl.addClass('editing');
      let titleEditEl = docEl.getElement('.doc-title-edit');
      let titleEl = docEl.getElement('.doc-title');
      titleEditEl.set('value', titleEl.get('text'));
      titleEditEl.activate();

      // eslint-disable-next-line no-var
      var stopEditing = function () {
         let newTitle = titleEditEl.value;
         if (newTitle === '') {
            newTitle = docEl.getProperty('data-title');
         }
         titleEl.set('text', newTitle);
         docEl.removeClass('editing');
         titleEditEl.removeEvent('clickoff', stopEditing);

         docEl.removeEvent('clickoff', stopEditing);
         docEl.removeEvent('keyup', stopEditingOnEnterOrTab);
      };

      // eslint-disable-next-line no-var
      var stopEditingOnEnterOrTab = function (ev) {
         if (ev.key == 'enter' || ev.key == 'tab') {
            ev.stop();
            stopEditing();
         }
      };

      titleEditEl.addEvent('clickoff', stopEditing);
      titleEditEl.addEvent('keydown', stopEditingOnEnterOrTab);
   },

   adjustCount: function (amount) {
      let count = this.count + amount;
      let phrase;
      if (count == 1) {
         phrase = this.countEl.getProperty('data-one');
      } else {
         phrase = this.countEl.getProperty('data-many');
         phrase = phrase.substitute({ count: count });
      }
      this.countEl.set('html', phrase);
      this.container.toggleClass('no-docs', count == 0);
      this.count = count;
   },

   getFormValues: function () {
      return this.docList.getElements('.doc').map(docEl => ({
         documentid: docEl.getElement('.doc-id').value,
         title: docEl.getElement('.doc-title-edit').value,
      }));
   },
};

const WikiRepairability = {
   initialize: function () {
      // Initialize the slider and keep it synchronized with the text input.
      when($('wikiRepairability'), scoreInput => {
         let slider = new RangeSlider($('repairabilitySlider'), {
            type: 'single',
            // -1 indicates an invalid score which will automatically be
            // removed because it's out of the acceptable range.
            range: [-1, 10],
            position: [Number.from(scoreInput.value)],
            onChange: function (step) {
               scoreInput.value = step;
            },
         });

         scoreInput.addEvent('change', () => {
            slider.set(scoreInput.value);
         });
      });
   },
};
